import { _ } from "~/i18n";
import { node } from "~/util/dom";
import { MAX_DESCRIPTION_LEN } from "../dialogs/const";
import { createPremiumIconWithTooltip } from "~/util/premium";

interface ICreateNote {
	text?: string;
	count?: number;
	isPremiumUser?: boolean;
	onChange?: (value: string) => void;
}

// vytvorit poznamku
export function createMyMapsNote({
	text = "",
	count = MAX_DESCRIPTION_LEN,
	isPremiumUser = true,
	onChange = () => {},
}: ICreateNote) {
	const note = node("div", { className: "mymaps-note" });
	const textarea = node("textarea", { className: "mymaps-note__textarea" });
	const countLine = node("div", { className: "mymaps-note__countLine" });
	const countLineRest = node("span", { className: "mymaps-note__countLineRest" });

	function updateRest() {
		const curLen = textarea.value.length;
		const restCount = count - textarea.value.length;

		countLineRest.innerHTML = _("detail.content.review.numOfChar", { chars: restCount });

		if (curLen === 0) {
			countLine.classList.remove("visible");
		} else {
			countLine.classList.add("visible");
		}
	}

	textarea.placeholder = _("note.addNote");
	textarea.value = text.slice(0, count);
	textarea.maxLength = count;
	note.append(textarea, countLine);

	if (text) {
		countLine.classList.add("visible");
	}

	if (isPremiumUser) {
		textarea.addEventListener("input", () => {
			updateRest();
			onChange(textarea.value);
		});
		countLine.append(countLineRest);
	} else {
		const premiumInfo = node("div", { className: "mymaps-note__premiumInfo" });
		const premiumInfoText = node("span", { className: "mymaps-note__premiumInfoTitle", textContent: _("note.addNote") });

		if (text) {
			premiumInfo.classList.add("has-text");
		} else {
			premiumInfo.classList.add("empty-text");
			premiumInfo.append(premiumInfoText);
		}

		textarea.classList.add("not-premium-user");
		premiumInfo.append(createPremiumIconWithTooltip());
		note.append(premiumInfo);
		textarea.disabled = true;
	}

	updateRest();

	return {
		container: note,
		textarea,
	};
}
